exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-icon {\n  font-size: 150%; }\n\n.eshop-status {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto; }\n\n.code-link {\n  position: relative;\n  z-index: 1;\n  /* ensure above any neighboring inline boxes/tooltips */ }\n\n.eshop-status {\n  pointer-events: none; }\n\n.eshop-status mat-icon {\n  pointer-events: auto; }\n\nmat-table mat-cell:first-child mat-icon {\n  font-size: 20px;\n  position: relative;\n  top: 4px; }\n  mat-table mat-cell:first-child mat-icon.inactive {\n    color: #ddd; }\n\nmat-table mat-cell mat-checkbox {\n  position: relative;\n  top: 3px; }\n\nmat-table mat-cell:last-child,\nmat-table mat-header-cell:last-child {\n  max-width: 150px;\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ProductsModule/ProductsListComponent/products-list.component.scss
// module id = ../../../../../src/ProductsModule/ProductsListComponent/products-list.component.scss
// module chunks = main